import axios from "axios";

import { VITE_BASE_URL_NAMEK } from "@/constants";

const axiosInstanceNamek = axios.create({
  baseURL: VITE_BASE_URL_NAMEK,
});

export default axiosInstanceNamek;
